import { BULK_SALARY_INCREASE_FILTER_NAMES } from "./constants";
import { NameIdOption } from "../../../common/types/commonTypes";
import { NumberRangeValue } from "../../../common/components/functional/fields/numberRange/types";
import { DateRange } from "@mui/x-date-pickers-pro";
import { Nullable } from "../../../common/types/nullable";
import { WorkTimeType } from "../../orders/types/workTimeType";

export type SalaryComponentRow = {
  changeSalary: string;
  increasePercentage: string;
  increaseAmount: string;
  code: string;
};

export type KtaComponentRow = {
  changeSalary: string;
  increasePercentage: string;
  increaseAmount: string;
  date: string;
};
export interface BulkSalaryIncreaseFilterValues {
  target: string;
  isIncreaseApplied: string; // boolean
  hasContEmp: Nullable<string>; // boolean
  baseEqualsGroup: Nullable<string>; // boolean
  salaryType: Nullable<string>;
  workTimeType: WorkTimeType[];
  tes: Nullable<NameIdOption>;
  salaryDateRange: DateRange<Date>;
  workTitles: NameIdOption[];
  salaryIncreaseStartDate: Nullable<Date>;
  salaryComponents: SalaryComponentRow[];
  ktaComponents: KtaComponentRow[];
  ktaKeskiansioComponents: KtaComponentRow[];
  isUnclear: Nullable<string>; // boolean
  /** When target is TES_TABLES: source / target published table ids (query shape only until backend fetch exists). */
  tesSalaryTableSourceId: string;
  tesSalaryTableTargetId: string;
  tesSalaryTableId: string;
  tesSelectionAtOrAfterRaise: Nullable<string>;
  tesSelectionModes: string[];
  // current salaries
  [key: `_${string}`]: NumberRangeValue;
}

export type BulkSalaryFilterOptionKeys =
  | BULK_SALARY_INCREASE_FILTER_NAMES.TARGET
  | BULK_SALARY_INCREASE_FILTER_NAMES.SALARY_TYPE
  | BULK_SALARY_INCREASE_FILTER_NAMES.IS_INCREASE_APPLIED
  | BULK_SALARY_INCREASE_FILTER_NAMES.HAS_CONT_EMP
  | BULK_SALARY_INCREASE_FILTER_NAMES.BASE_EQUALS_GROUP
  | BULK_SALARY_INCREASE_FILTER_NAMES.WORK_TIME_TYPE
  | BULK_SALARY_INCREASE_FILTER_NAMES.IS_UNCLEAR
  | BULK_SALARY_INCREASE_FILTER_NAMES.TES_SELECTION_AT_OR_AFTER_RAISE
  | BULK_SALARY_INCREASE_FILTER_NAMES.TES_SELECTION_MODES;

export interface BulkSalaryIncreaseProcessingState {
  isProcessing: boolean;
  isCanceled: boolean;
  isCompleted: boolean;
  isPreviewing: boolean;
}

export enum GetUniqueSalaryKeysCallbackType {
  RAISE_DATE_SALARY = "raiseDateSalary",
  AFTER_RAISE_SALARY_PER_DATE = "afterRaiseSalaryPerDate",
}

export type GetUniqueSalaryKeysCallback = (
  type: GetUniqueSalaryKeysCallbackType,
) => string[];
